import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import gpt from '../../gptAPI';
import Prompts from '../../common';

export default function GenerateCategories(props) {
	const { company, setCategories, prompts, settings } = props;
	const [state, setState] = useState<any>({});
	const { resCategories, loading, error } = state;
	const handlerGenerate = () => {
		gpt.generateCategories(
			{
				description: company,
				prompt: prompts[Prompts.category],
				model: settings.model
			},
			setState
		);
	};

	const handlerSave = () => {
		setCategories(resCategories);
	};

	return (
		<Box
			component='form'
			sx={{
				'& .MuiTextField-root': { m: 1, width: '25ch' }
			}}
			noValidate
			autoComplete='off'
		>
			{error && (
				<Alert severity='error'>
					<AlertTitle>Error</AlertTitle>
					it can be wrong answer format — <strong>try again</strong>
				</Alert>
			)}
			<div>
				<LoadingButton
					variant='contained'
					onClick={() => handlerGenerate()}
					loading={loading}
					loadingPosition='end'
				>
					Generate categories
				</LoadingButton>
				<Button variant='outlined' onClick={() => handlerSave()}>
					Save categories
				</Button>
			</div>
			<div>
				{/* <div><pre>{JSON.stringify(resCategories, null, 2) }</pre></div> */}
				<pre>{JSON.stringify(resCategories, null, 2)}</pre>
			</div>
		</Box>
	);
}
